import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "receipt-check-status__state" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.state)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["receipt-check-status", `receipt-check-status--${_ctx.state}`])
      }, [
        _createElementVNode("span", _hoisted_1, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "receipt-check-status__dot" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans(`dispute_reason.${_ctx.reason}`)), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reasons, (text) => {
          return (_openBlock(), _createElementBlock("span", {
            key: text,
            class: "receipt-check-status__reason"
          }, _toDisplayString(text), 1))
        }), 128))
      ], 2))
    : _createCommentVNode("", true)
}